import { useState } from 'react';
import { categories } from '@/mocks/categories';

export default function HeroSection() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20vibrant%20and%20diverse%20product%20flat%20lay%20photography%20with%20multiple%20fashion%20and%20lifestyle%20items%20including%20stylish%20sneakers%20a%20leather%20watch%20designer%20sunglasses%20a%20sleek%20bag%20folded%20hoodie%20and%20small%20accessories%20all%20arranged%20beautifully%20on%20a%20warm%20cream%20linen%20fabric%20surface%20with%20soft%20golden%20afternoon%20sunlight%20casting%20gentle%20shadows%20premium%20editorial%20catalog%20photography%20clean%20minimalist%20composition%20warm%20neutral%20tones&width=1600&height=900&seq=hero-new-products-v3&orientation=landscape"
          alt="Vigorbuy Spreadsheet Hub - Product Discovery Platform"
          title="Vigorbuy Spreadsheet Hub"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/90 backdrop-blur-sm mb-6">
          <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
          <span className="text-xs md:text-sm text-foreground-700 font-medium whitespace-nowrap">Updated Regularly · 14+ Categories</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-5">
          Vigorbuy Spreadsheet 2026
          <br />
          <span className="text-accent-300">The Ultimate Product Discovery Database</span>
        </h1>

        <p className="text-white/80 text-sm md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
          Discover thousands of organized product links, quality guides, category spreadsheets, and expert buying resources — all in one place. Find sneakers, clothing, accessories, and more through our structured database.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer text-sm md:text-base"
          >
            <i className="ri-search-line w-4 h-4 flex items-center justify-center"></i>
            Vigorbuy Spreadsheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-accent-500 hover:bg-accent-600 text-white font-semibold rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer text-sm md:text-base"
          >
            <i className="ri-shopping-cart-line w-4 h-4 flex items-center justify-center"></i>
            Buy It Now
          </a>
        </div>

        <div className="relative w-full max-w-md mx-auto">
          <button
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            className="w-full flex items-center justify-between gap-3 px-5 py-3.5 bg-white rounded-xl text-foreground-800 font-medium cursor-pointer transition-all duration-200 hover:bg-background-100 border border-background-200 text-sm"
          >
            <div className="flex items-center gap-2">
              <i className="ri-grid-line w-4 h-4 flex items-center justify-center text-primary-500"></i>
              <span>Browse Product Categories</span>
            </div>
            <i className={`${isDropdownOpen ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} w-4 h-4 flex items-center justify-center text-foreground-500 transition-transform duration-200`}></i>
          </button>

          {isDropdownOpen && (
            <div className="absolute top-full left-0 right-0 mt-2 bg-white rounded-xl border border-background-200 shadow-lg overflow-hidden z-50 max-h-[380px] overflow-y-auto">
              <div className="py-2">
                {categories.map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    onClick={() => setIsDropdownOpen(false)}
                    className="flex items-center gap-3 px-5 py-3 hover:bg-background-100 transition-colors duration-150 cursor-pointer text-sm text-foreground-700 hover:text-foreground-950"
                  >
                    <i className={`${cat.icon} w-4 h-4 flex items-center justify-center text-primary-400`}></i>
                    <span className="whitespace-nowrap">{cat.name}</span>
                  </a>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 mt-8 text-white/70 text-xs md:text-sm">
          <span className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-checkbox-circle-line w-4 h-4 flex items-center justify-center text-accent-300"></i>
            Updated Regularly
          </span>
          <span className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-checkbox-circle-line w-4 h-4 flex items-center justify-center text-accent-300"></i>
            Organized Product Database
          </span>
          <span className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-checkbox-circle-line w-4 h-4 flex items-center justify-center text-accent-300"></i>
            Beginner Friendly Guides
          </span>
          <span className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-checkbox-circle-line w-4 h-4 flex items-center justify-center text-accent-300"></i>
            Safety Information Included
          </span>
        </div>
      </div>

      {isDropdownOpen && (
        <div
          className="fixed inset-0 z-40"
          onClick={() => setIsDropdownOpen(false)}
        ></div>
      )}
    </section>
  );
}